import React from 'react';

const LoadingIcon = (props) => {
	return <img src="/Content/Images/ajax-loader.gif" />;
}

export default LoadingIcon;